import PropTypes from 'prop-types';
import React from 'react';
import {
  LINK_CHECKOUT,
  LINK_LOGIN,
  LINK_MY_VOUCHERS,
  LINK_WISHLIST,
} from '../../config/links/links';
import HeaderIcon from './HeaderIcon';

const HeaderButtons = ({ bt }) => {
  return (
    <>
      <div className="d-flex justify-content-end col col-md-auto order-md-12">
        {/*  <HeaderIcon icon="location" /> */}
        {/* <HeaderIcon
          href={`${process.env.NEXT_PUBLIC_BASE_ROOT_URL}${LINK_MY_VOUCHERS}`}
          icon="subscribe"
        /> */}
        <HeaderIcon
          href={`${process.env.NEXT_PUBLIC_BASE_ROOT_URL}${LINK_MY_VOUCHERS}`}
          icon="login"
        />
        <HeaderIcon
          href={`${process.env.NEXT_PUBLIC_BASE_ROOT_URL}${LINK_WISHLIST}`}
          icon="wishlist"
        />
        <HeaderIcon
          href={
            bt
              ? `${process.env.NEXT_PUBLIC_BASE_ROOT_URL}${LINK_CHECKOUT}/${bt}`
              : `${process.env.NEXT_PUBLIC_BASE_ROOT_URL}${LINK_LOGIN}`
          }
          icon="basket"
        />
      </div>
    </>
  );
};

HeaderButtons.propTypes = {
  bt: PropTypes.string,
};

export default HeaderButtons;
